import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const ViewRolePermissions = React.lazy(() => import('./ViewRolesPermission'));

const RolesView: React.FC = () => {
    const drawer = useSelector((state: any) => state.drawer);

    return (
        <Box>
            {drawer?.name === 'handleOpenViewDialog' && <ViewRolePermissions />}
        </Box>
    )
}

export default RolesView